import { render } from "./EditHistoriquePage.vue?vue&type=template&id=279331b8&ts=true"
import script from "./EditHistoriquePage.vue?vue&type=script&lang=ts"
export * from "./EditHistoriquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__